import { createBrowserHistory, BrowserHistory } from 'history';

export const history: BrowserHistory =
  typeof document !== 'undefined'
    ? createBrowserHistory()
    : ({} as BrowserHistory);
